import React from 'react';

import { GridProps, SystemStyleObject } from '@chakra-ui/react';

export interface MediaProps extends GridProps {
    breakOn?: 'md' | 'lg' | 'xl' | undefined;
    image?: React.ReactNode;
    imageWidth?: SystemStyleObject['width'];
    imageVerticalAlign?: GridProps['alignSelf'];
    bodyVerticalAlign?: GridProps['alignSelf'];
    bodyTextAlign?: SystemStyleObject['textAlign'];
    reversed?: boolean;
    children?: React.ReactNode;
}
